import $http from '../../axios';
import {Notification, MessageBox} from 'element-ui';
import {setFinalizeVoucherAlkosto} from "./mutations";

export async function fetchProcess({commit, state},confirmation) {
    state.loading.module = true;

    if (confirmation){
        state.params.confirmation = confirmation
    }

    await $http
        .post('/api/re-clasificacion-cartera-alkosto', state.params)
        .then(response => {
            state.loading.module = false;
            state.params.confirmation = false;
            Notification.success({
                title: 'Exito!',
                message: response.data.message,
                type: 'success',
                duration: 1500,
                customClass: 'notification-box'
            });
            commit("setFinalizeVoucherAlkosto", response.data.data);

        })
        .catch(error => {
            state.loading.module = false;
            commit("setFormAlokstosProccessResponse", error.response.data);
        });
}

export async function fetchReportAlkosto({commit, state},confirmation) {
    state.loading.module = true;

    if (confirmation){
        state.params.confirmation = confirmation
    }

    await $http
        .get('/api/get-data-re-clasificacion-cartera-alkosto', {params: state.params})
        .then(response => {
            state.loading.module = false;
            state.params.confirmation = false;
            commit('setDataReport', response.data.data);
            Notification.success({
                title: 'Exito!',
                message: response.data.message,
                type: 'success',
                duration: 1500,
                customClass: 'notification-box'
            });
        })
        .catch(error => {
            state.loading.module = false;
            commit("setResponseAlkostos", error.response.data);
        });
}

export async function fetchBranchOfficesAlkosto ({ commit, state }) {
    await $http.get('/api/sedes')
        .then((response) => {
            commit('setBranchOffices', response.data.data)
        })
        .catch((error) => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 2000,
                customClass: 'notification-box',
            });
        })
}



// WEBPACK FOOTER //
// ./src/modules/portfolio_reclassification/actions.js